import axios from "axios";

const instance = axios.create({
  baseURL: "https://tinders-back.herokuapp.com/",
});

export default instance;
